module.exports = "/packs/media/images/FinancesOnTrack-0a888c74325aa475a7fc4c19abd93ce7.png";